import FileInput from '../../components/FileInput';

export default class CustomCompaints {
    private fileInput = new FileInput('complaint_form', ['image/jpeg', 'image/png', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'application/pdf', 'application/rtf', 'application/vnd.oasis.opendocument.text']);
    private successClasses = ['bg-green-700', 'text-white', 'mt-5', 'px-4', 'py-2', 'text-sm', 'rounded', 'shadow-md', 'overflow-hidden'];
    private inputErrorClasses = ['error'];
    private form = document.querySelector('#complaint_form') as HTMLFormElement;
    private inputs = {};

    constructor() {
        if (app_extra.isUserLoggedIn == 1) {
            this.inputs = {
                the_problem: this.form.querySelector('[name="problem"]') as HTMLTextAreaElement,
                expected: this.form.querySelector('[name="expect"]') as HTMLTextAreaElement,
            }
            this.addSubmitEvent();
            this.handleToggleProduct();
            this.handleSelectAllProducts();
            this.addTextAreaEvent();
        }
    }

    private addTextAreaEvent() {
        this.inputs.the_problem.addEventListener('input', this.handleTextAreaInput);
        this.inputs.expected.addEventListener('input', this.handleTextAreaInput);
    }

    private addSubmitEvent() {
        this.form.addEventListener('submit', this.handleSubmit);
    }

    private handleTextAreaInput = (event: Event) => {

        const target = event.target as HTMLTextAreaElement;
        const value = target.value;
        const length = value.length;
        const counter = target.parentNode?.querySelector('.counter') as HTMLSpanElement;
        counter.textContent = length.toString();

        if (length >= 1000) {
            target.classList.add(...this.inputErrorClasses);
            counter.classList.add(...['text-red-700', 'font-bold']);
        } else {
            target.classList.remove(...this.inputErrorClasses);
            counter.classList.remove(...['text-red-700', 'font-bold']);
        }
    }

    private handleSelectAllProducts() {
        const check = this.form.querySelector('#product_list_check_all') as HTMLInputElement;
        check?.addEventListener('change', () => {
            const products = this.form.querySelectorAll('.list-select-product') as NodeListOf<HTMLInputElement>;
            products.forEach(product => {
                const product_input = product.parentElement?.querySelector('[name="products[]"]') as HTMLInputElement;

                if (check.checked) {
                    product.checked = true;
                    product_input.disabled = false;
                    this.changeLabelIfAllProductsAreSelected(true);
                } else {
                    product.checked = false;
                    product_input.disabled = true;
                    this.changeLabelIfAllProductsAreSelected(false);
                }
            })


        })
    }

    private changeLabelIfAllProductsAreSelected(state: Boolean) {
        const input = this.form.querySelector('#product_list_check_all') as HTMLInputElement;
        const span = input.parentElement?.querySelector('span') as HTMLSpanElement;

        if (state) {
            span.innerHTML = span.parentElement?.querySelector('span')?.dataset.all
        } else {
            span.innerHTML = span.parentElement?.querySelector('span')?.dataset.not_all
        }
    }

    private checkIfAllProductsAreSelected() {
        const products = this.form.querySelectorAll('.list-select-product') as NodeListOf<HTMLInputElement>;
        const check = this.form.querySelector('#product_list_check_all') as HTMLInputElement;
        let allSelected = true;
        products.forEach(product => {
            if (!product.checked) {
                allSelected = false;
            }
        })
        if (allSelected) {
            check.checked = true;
            this.changeLabelIfAllProductsAreSelected(true);
        } else {
            check.checked = false;
            this.changeLabelIfAllProductsAreSelected(false);
        }
    }

    private handleToggleProduct() {
        const products = this.form.querySelectorAll('.list-select-product') as NodeListOf<HTMLInputElement>;
        products.forEach(product => {
            product.addEventListener('change', () => {
                const product_input = product.parentElement?.querySelector('[name="products[]"]') as HTMLInputElement;
                product_input.disabled = product_input.disabled ? false : true;
                this.checkIfAllProductsAreSelected();
            })
        }
        );
    }

    private handleSubmit = (event: Event) => {
        event.preventDefault();

        const form = event.target as HTMLFormElement;
        const formData = new FormData(form);
        formData.append('action', 'create_refund');
        formData.append('nonce', window.app_extra.nonce);

        const files = Object.entries(this.fileInput.getFileList());
        for (let i = 0; i < files.length; i++) {
            formData.append("files[]", files[i][1]);
        }

        const submitButton = this.form.querySelector('.submit') as HTMLButtonElement;
        if (this.valdateForm()) {
            submitButton.classList.add('loading');
            this.submitReview(formData);
        }
    }

    private submitReview = async (formData: FormData) => {
        const res = await fetch(window.app_extra.ajaxUrl, {
            method: 'POST',
            body: formData,
        });
        const data = await res.json();
        if (data.success) {
            this.handleSuccess(data.data);
        } else {
            this.handleError(data.data);
        }
    }

    private handleSuccess = (data: any) => {
        const successMessage = document.createElement('div') as HTMLDivElement;
        successMessage.textContent = data.message;
        successMessage.classList.add(...this.successClasses);

        this.form.parentNode?.appendChild(successMessage);
        this.form.remove();

        setTimeout(() => {
            successMessage.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }, 300);
    }

    private handleError = (data: any) => {
        const submitButton = this.form.querySelector('.submit') as HTMLButtonElement;
        submitButton.classList.remove('loading');
    }

    private addErrorClassesToInput = (field: any) => {
        field.classList.add(...this.inputErrorClasses);
    }

    private resetValidationMessages = () => {
        const errors = this.form.querySelectorAll('.error');
        errors?.forEach((error) => {
            error.classList.remove(...this.inputErrorClasses);
        })
    }

    private minimumProductSelected = () => {
        const products = this.form.querySelectorAll('.list-select-product') as NodeListOf<HTMLInputElement>;
        let selected = 0;
        products.forEach(product => {
            if (product.checked) {
                selected++;
            }
        });
        return selected > 0;
    }

    private valdateForm = () => {

        this.resetValidationMessages();
        let returnState = true;

        if (!this.inputs.the_problem.value) {
            returnState = false;
            this.addErrorClassesToInput(this.inputs.the_problem);
        }
        if (!this.inputs.expected.value) {
            returnState = false;
            this.addErrorClassesToInput(this.inputs.expected);
        }
        if (!this.minimumProductSelected()) {
            returnState = false;
            const products = this.form.querySelectorAll('.list-select-product') as NodeListOf<HTMLInputElement>;
            products.forEach(product => {
                const product_input = product.parentElement?.querySelector('[name="products[]"]') as HTMLInputElement;
                this.addErrorClassesToInput(product);
            })
        }

        return returnState;
    }
}